<template>
  <div class="vehicle-drilldown">
    <div class="change-vehicle" v-if="selectedVehicle.full_name">
        <strong>{{ your_vehicle_is_set_to }}</strong>
        <p>{{ selectedVehicle.full_name }}</p>
        <a :href="fullUrl + '?type_id=' + url_query" class="full-button btn btn-hover btn-primary btn-blue" v-if="url_query">{{ label_change_vehicle }}</a>
        <a :href="fullUrl + '?change'" class="full-button btn btn-hover btn-primary btn-blue" v-if="!url_query">{{ label_change_vehicle }}</a>
    </div>
    <div class="form" v-if="!selectedVehicle.full_name">
      <div class="form-content">
        <div v-show="enable_rego_lookup == 'yes' && showRego">
            <h4><a href="#" v-on:click.self.prevent="showRego = false;">Back to Search By Vehicle</a></h4>
            <div class="form-row">
                <label for>State</label>
                <select v-model="state" dusk="State">
                    <option value="" disabled>{{ label_select }}</option>
                    <option value="ACT">ACT</option>
                    <option value="NSW">NSW</option>
                    <option value="NT">NT</option>
                    <option value="Qld">QLD</option>
                    <option value="SA">SA</option>
                    <option value="Vic">VIC</option>
                    <option value="Tas">TAS</option>
                    <option value="WA">WA</option>
                </select>
            </div>

            <div v-show="state !== '' && state !== 'SA' && state !== 'VIC'">
                <div class="form-row">
                    <label for>Rego Plate Number</label>
                    <input type="text" v-model="rego" placeholder="XXX XXX" />
                </div>
                <div class="form-row">
                    <button @click="getRegoDetails()" class="btn btn-hover btn-primary">Find My Car</button>
                </div>
            </div>

            <div v-show="state === 'SA' || state === 'VIC'">
                Sorry, we currently don't have vehicle data for SA or VIC.<br />
                <a href="#" v-on:click.self.prevent="showRego = false;">Back to Search By Vehicle</a>
            </div>

        </div>
        <div>
          <h3>Select Your Vehicle</h3>
            <div class="form-row">
            <label for>{{ label_manufacturer }}</label>
            <select name :id="label_manufacturer" v-model="manufacturerId" dusk="Manufacturer" @change="triggerGA">
                <option value="0" disabled>{{ label_select }}</option>
                <option
                v-for="(manufacturer, index) in manufacturers"
                :key="index"
                :id="manufacturer.manufacturerId"
                :value="manufacturer.manufacturerId"
                :dusk="manufacturer.title"
                >{{ manufacturer.title }}</option>
            </select>
            </div>

            <div class="form-row">
            <label for>{{ label_model }} </label>
            <select name :id="label_model" v-model="modelId" :disabled="models.length == 0" dusk="Model" @change="triggerGA">
                <option value="0" disabled>{{ label_select }}</option>
                <option
                v-for="(model, index) in models"
                :key="index"
                :id="model.modelId"
                :value="model.modelId"
                :dusk="model.title"
                >{{ model.title }}</option>
            </select>
            </div>

            <div class="form-row">
            <label for>{{ label_year }}</label>
            <select name :id="label_year" v-model="year" :disabled="years.length == 0"  dusk="Year" @change="triggerGA">
                <option value="0" disabled>{{ label_select }}</option>
                <option v-for="(year, index) in years" :key="index" :value="year" :dusk="'year_' + year">{{ year }}</option>
            </select>
            </div>

            <div class="form-row">
            <label for> {{ label_body_type }}</label>
            <select name id="body_type" v-model="bodyTypeId" :disabled="bodyTypes.length == 0"  dusk="body_type" @change="triggerGA">
                <option value="0" disabled>{{ label_select }}</option>
                <option
                v-for="(bodyType, index) in bodyTypes"
                :key="index"
                :value="bodyType.bodyTypeId"
                :dusk="'body_type_' + bodyType.title"
                >{{ bodyType.title }}</option>
            </select>
            </div>

            <div class="vehicle-selection" v-show="vehicles.length > 0">
            <p>{{ label_select_vehicle }}</p>
            <div v-for="(vehicle, index) in vehicles" :key="index">
                <input
                type="radio"
                :id="vehicle.Vehicle.vehicleId"
                name="vehicleId"
                :value="vehicle.Vehicle"
                v-model="newSelectedVehicle"
                :dusk="'vehicle_' + vehicle.Vehicle.full_name"
                />
                <label :for="vehicle.Vehicle.vehicleId">{{ vehicle.Vehicle.full_name }}</label>
            </div>

            <button dusk="select_vehicle" class="btn btn-hover btn-primary" @click="selectVehicle()">{{ label_select_vehicle }}</button>
            </div>

            <div class="overlay" v-show="loading" dusk="loading_overlay">
            <p class="loading"><img src="/cdn/images/loading.gif" width="100" /></p>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vehicle-drilldown",
  props: {
    selectedVehicle: {
      type: Object
    },
        link: {
      type: String
    },
    label_manufacturer: {
      type: String,
      default: "Manufacturer"
    },
    label_model: {
      type: String,
      default: "Model"
    },
    label_year: {
      type: String,
      default: "Year"
    },
    label_body_type: {
      type: String,
      default: "Body Type"
    },
    label_loading: {
      type: String,
      default: "Loading"
    },
    label_select: {
      type: String,
      default: "Select"
    },
    label_select_vehicle: {
      type: String,
      default: "Select Vehicle"
    },
    your_vehicle_is_set_to: {
      type: String,
      default: "Your vehicle is set to"
    },
    label_change_vehicle: {
      type: String,
      default: "Change Vehicle"
    },
    enable_rego_lookup: {
        type: String,
        default: "false"
    }
  },
  data() {
    return {
      manufacturers: [],
      manufacturerId: 0,
      models: [],
      modelId: 0,
      years: [],
      year: 0,
      bodyTypes: [],
      bodyTypeId: 0,
      vehicles: [],
      loading: true,
      newSelectedVehicle: {},
      url_query : "",
      rego: "",
      state: "",
      maintain: false,
      showRego: false,
      showRegoNotFound: false
    };
  },
  computed: {
      fullUrl() {
      return `/${window.culture}${this.link}`;
    },
    selectedVehicleModel: {
      get: function() {
        return this.selectedVehicle;
      },
      set: function(vehicle) {
        this.newSelectedVehicle = vehicle;
      }
    }
  },
  mounted() {
    // alert(this.item);
    this.url_query = this.getUrlParameter('type_id');
    this.getVehicleManufacturers();
    if(this.url_query){
      this.resetVehicle();
    }
  },
  methods: {
    triggerGA(event) {
      if(event){
        let selectedValue = event.target.options[event.target.selectedIndex].getAttribute('dusk');
        let inputName = event.target.id;
        ga('send','event', 'Fit My Vehicle', inputName ,selectedValue);
            gtag('event', 'fit_my_vehicle_vehicle', {'category':'Fit My Vehicle', 'action':inputName, value: selectedValue});
      };
    },
    async getRegoDetails() {

        ga('send', 'event', 'License Plate Lookup ', this.state, this.rego);
            gtag('event', 'fit_my_vehicle_license_plate', {'category':'License Plate Lookup', 'action':this.state, value: this.rego});

        this.manufacturerId = 0;
        this.modelId = 0;
        this.year = 0;
        this.bodyTypeId = 0;
        let response = await axios.get('api/solutions/rego?rego=' + this.rego + '&state=' + this.state);
        this.maintain = true;


       if (response && response.data.data && response.data.success) {
            if (response.data.data.manufacturer) {
                this.manufacturerId = response.data.data.manufacturer;
                if (response.data.data.model) {
                    this.modelId = response.data.data.model;
                    if (response.data.data.year) {
                        this.year = response.data.data.year;
                        if (response.data.data.body) {
                            this.bodyTypeId = response.data.data.body;
                        }
                    }
                }
            }
        }else{



        }



        this.showRego = false;
        setTimeout(() => {
            this.maintain = false;
        }, 2000);
    },
    resetVehicle() {
      this.$emit("selectVehicle", {});
      this.manufacturerId = 0;
    },
    selectVehicle() {
      this.$emit("selectVehicle", this.newSelectedVehicle);
    },
    async getVehicleManufacturers() {
      let response;
      if(this.url_query)
        response = await axios.get("api/vehicle/makes?type_id="+this.url_query);
      else
        response = await axios.get("api/vehicle/makes");

      this.manufacturers = response.data.data;
        this.loading = false;
    },
    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
  },
  watch: {
    async manufacturerId() {
      if (!this.maintain) {
        this.modelId = 0;
      }
      this.loading = true;
      try {
        let url;
        if(this.url_query)
          url = `api/vehicle/models/${this.manufacturerId}`+'?type_id='+this.url_query;
        else
          url = `api/vehicle/models/${this.manufacturerId}`;

        let response = await axios.get(url);
        this.models = response.data.data;
        if (this.models.length == 1) {
          this.modelId = this.models[0].modelId;
        }
        this.loading = false;
      } catch (err) {}
    },
    async modelId() {
      if (!this.maintain) {
        this.year = 0;
      }
      this.loading = true;
      try {
        let url;
        if(this.url_query)
          url = `api/vehicle/model/years/${this.modelId}`+'?type_id='+this.url_query;
        else
          url = `api/vehicle/model/years/${this.modelId}`;

        let response = await axios.get(url);
        this.years = response.data.data;
        if (this.years.length == 1) {
          this.year = this.years[0];
        }
        this.loading = false;
      } catch (err) {}
    },
    async year() {
      if (!this.maintain) {
        this.bodyTypeId = 0;
      }
      this.loading = true;
      try {
        let url;
        if(this.url_query)
          url = `api/vehicle/model/body-types/${this.modelId}/${this.year}`+'?type_id='+this.url_query;
        else
          url = `api/vehicle/model/body-types/${this.modelId}/${this.year}`;
        let response = await axios.get(url);
        this.bodyTypes = response.data.data;
        if (this.bodyTypes.length == 1) {
          this.bodyTypeId = this.bodyTypes[0].bodyTypeId;
        }
        this.loading = false;
      } catch (err) {}
    },
    async bodyTypeId() {
      this.loading = true;
      try {
        let url;
        if(this.url_query)
          url = `api/vehicle/retrieve/${this.modelId}/${this.year}/${this.bodyTypeId}`+'?type_id='+this.url_query;
        else
          url = `api/vehicle/retrieve/${this.modelId}/${this.year}/${this.bodyTypeId}`;
        let response = await axios.get(url);
        this.vehicles = response.data.data;
        if (this.vehicles.length == 1) {
          this.newSelectedVehicle = this.vehicles[0].Vehicle;
        }
        this.loading = false;
      } catch (err) {}
    }
  }
};
</script>
